/**
 * A label attached to a shareable (file, folder, dashboard, ...).
 *
 * Labels are scoped per shareable — the same text can appear on different
 * shareables independently. The tuple `(shareable, text)` is unique on the
 * backend; sending the same text again acts as an upsert that replaces the
 * color.
 */
export interface ShareableLabel {
  text: string;
  color: string | null;
}

/**
 * Matches the backend color validation: `#RRGGBB` hex, case-insensitive.
 */
export const SHAREABLE_LABEL_COLOR_PATTERN = /^#[0-9A-Fa-f]{6}$/;

export function isValidShareableLabelColor(color: string | null): boolean {
  return color === null || SHAREABLE_LABEL_COLOR_PATTERN.test(color);
}
